/**
 * /settings/legal-entity-agent — Mutaba'aa LE provisioning +
 * PDPL routing + divestment (Pack 15 v2 UI).
 */

import { PageHeader } from "../components/ui";
import { AgentBadge } from "../components/ui/AgentBadge";

export function LegalEntityAgentPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Legal Entity Agent"
        subtitle="Mutaba'aa drives LE provisioning, PDPL-compliant region routing, and divestment workflows."
      />

      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <AgentBadge agent="mutabaa" />
          <h3 className="text-base font-semibold">LE provisioning stages</h3>
        </div>
        <ol className="text-sm text-text-secondary space-y-1.5 list-decimal pl-5">
          <li>Draft — initial CR + tenant entry</li>
          <li>CR verified — government CR confirmed via Wathiq</li>
          <li>GOSI registered — employer subscription active</li>
          <li>Mudad registered — WPS file routing active</li>
          <li>ZATCA registered — VAT / Zakat profile created</li>
          <li>Live — first payroll cycle scheduled by Rawatib</li>
        </ol>
      </section>

      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <AgentBadge agent="mutabaa" />
          <h3 className="text-base font-semibold">PDPL region routing</h3>
        </div>
        <p className="text-sm text-text-secondary">
          Saudi tenants route to the Bahrain-region Postgres cluster
          (AWS me-south-1) for PDPL compliance. Mutaba'aa enforces the
          routing decision at LE provisioning time.
        </p>
      </section>

      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <AgentBadge agent="mutabaa" />
          <h3 className="text-base font-semibold">Divestment workflow</h3>
        </div>
        <p className="text-sm text-text-secondary">
          When an LE winds down, Mutaba'aa orchestrates: GOSI exit
          batch, WPS final file, employee transfer (Article 18
          succession to target LE), data archival per PDPL retention.
        </p>
      </section>
    </div>
  );
}
